<app-simple-responsive-frame>
    <div class="details">
        <div class="intro">
            <h2>Agrega los detalles básicos de tu {{ segmentLabel?.toLowerCase() }}</h2>
            <span>Podrás agregar más detalles en los siguientes pasos.</span>
        </div>

        <!-- GRID RESPONSIVE -->
        <div class="details-grid">
            <p-card *ngFor="let group of valuePrimaryList; trackBy: trackByGroup" styleClass="card">
                <div class="card-header">
                    <h5 class="section-title">{{ group.groupLabel }}</h5>
                    <span class="total-badge">{{ computeGroupTotal(group) }}</span>
                </div>

                <div class="flex-column">
                    <ng-container *ngFor="let feature of group.featureList; trackBy: trackByFeature">
                        <div *ngIf="!feature.featureCode.includes('TOTAL')" class="input-row">
                            <label [for]="feature.featureCode" class="label">
                                {{ feature.featureLabel }}
                            </label>

                            <ng-container [ngSwitch]="feature.ctInputType">
                                <!-- Enteros con + / - -->
                                <div class="counter" *ngSwitchCase="'WHOLE_NUMERIC_INPUT'">
                                    <button type="button" class="btn" (click)="decrementFeature(feature.featureCode)" [attr.aria-label]="'Disminuir ' + feature.featureLabel">−</button>

                                    <input
                                        [id]="feature.featureCode"
                                        type="number"
                                        inputmode="numeric"
                                        min="0"
                                        class="number-input"
                                        [(ngModel)]="formData[feature.featureCode]"
                                        (ngModelChange)="sanitizeWhole(feature.featureCode)" />

                                    <button type="button" class="btn" (click)="incrementFeature(feature.featureCode)" [attr.aria-label]="'Aumentar ' + feature.featureLabel">+</button>
                                </div>

                                <!-- Decimales -->
                                <div class="decimal" *ngSwitchCase="'DECIMAL_NUMERIC_INPUT'">
                                    <input
                                        [id]="feature.featureCode"
                                        type="number"
                                        inputmode="decimal"
                                        step="0.01"
                                        min="0"
                                        class="number-input wide"
                                        [(ngModel)]="formData[feature.featureCode]"
                                        (ngModelChange)="sanitizeDecimal(feature.featureCode)" />
                                </div>

                                <!-- Booleano (switch) -->
                                <div class="switch" *ngSwitchCase="'BOOLEAN_INPUT'">
                                    <p-inputSwitch
                                        [(ngModel)]="formData[feature.featureCode]"
                                        (ngModelChange)="onValueChanged(feature.featureCode)"
                                        [attr.aria-label]="feature.featureLabel">
                                    </p-inputSwitch>
                                </div>

                                <!-- Texto (fallback) -->
                                <div class="text" *ngSwitchDefault>
                                    <input
                                        [id]="feature.featureCode"
                                        type="text"
                                        class="text-input"
                                        [(ngModel)]="formData[feature.featureCode]"
                                        (ngModelChange)="onValueChanged(feature.featureCode)" />
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </p-card>
        </div>
    </div>

    <app-page-navigation-bar
        [value]="45"
        [type]="'complete'"
        [previousPageURL]="previousUrl"
        [nextPageURL]="nextUrl"
        [flowMode]="currentMode"
        [stepKey]="'details-primary'"
        (goNext)="handleNextStep()"
        (goPrevious)="handlePreviousStep()"
        (saveAndExit)="handleSaveAndExit()">
    </app-page-navigation-bar>
</app-simple-responsive-frame>
